module.exports = __webpack_public_path__ + "img/left_icon.372f6636.svg";